import type { PracticeLessonClass } from "@circleofa/acim-engine"
import { timeCrunchMachine, type LessonTime } from "./reminder-time-conversion"

export function breakdown(lesson: PracticeLessonClass) {
    const times = lesson.practices.flatMap((practice) =>
        practice.time ? [[practice, timeCrunchMachine(practice.time)] as const] : [],
    )
    const map = new Map(times)
    return map
}

// @ts-expect-error debug
globalThis.breakdown = breakdown
